// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { createTermsOfServiceRequestToJson, getTermsOfServiceRequestToJson, getTermsOfServiceResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function getTermsOfService(request) {
    const raw = await fetchRpc('partner.v1.PartnerTermsOfService/GetTermsOfService', getTermsOfServiceRequestToJson(request));
    return getTermsOfServiceResponseFromJson(raw);
}
export function getTermsOfService$(request, options) {
    return defer(() => getTermsOfServiceWithTransport$(getGlobalTransport(), request, options));
}
export function getTermsOfServiceWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.PartnerTermsOfService/GetTermsOfService', getTermsOfServiceRequestToJson(request), options)
        .pipe(map(resp => getTermsOfServiceResponseFromJson(resp)));
}
export async function createTermsOfService(request) {
    await fetchRpc('partner.v1.PartnerTermsOfService/CreateTermsOfService', createTermsOfServiceRequestToJson(request));
}
export function createTermsOfService$(request, options) {
    return defer(() => createTermsOfServiceWithTransport$(getGlobalTransport(), request, options));
}
export function createTermsOfServiceWithTransport$(transport, request, options) {
    return transport
        .post('partner.v1.PartnerTermsOfService/CreateTermsOfService', createTermsOfServiceRequestToJson(request), options)
        .pipe(map(() => undefined));
}
